import { getAddOnByName } from "./subscriptionUtils";

const DEFAULT = "DEFAULT";

export function isCoupledAddOn(addOnName) {
  // first check the addOn's relation
  const addOn = getAddOnByName(addOnName);
  if (addOn) {
    const isParent = addOn.configuration.subscriptionAcquires !== undefined ? true : false;

    // if parent
    if (isParent) {
      const childAddOnName = getChildAddOnFromAcquires(addOn);

      if (childAddOnName) {
        const childAddOn = childAddOnName ? getAddOnByName(childAddOnName) : null;
        const parentAddOnName = childAddOn ? getParentAddOnFromSubscriptionInherits(childAddOn, addOnName) : null;
        return parentAddOnName
          ? {
              child: childAddOnName,
              parent: parentAddOnName
            }
          : null;
      }
      return null;
    } else {
      // if child
      const childAddOn = addOn;
      const parentAddOnName = getParentAddOnFromChildSubscriptionInherits(childAddOn);
      return parentAddOnName
        ? {
            child: addOnName,
            parent: parentAddOnName
          }
        : null;
    }
  }
  return null;
}

export function getChildAddOnFromAcquires(addOn) {
  const childAddOnName =
    addOn.configuration.subscriptionAcquires !== "" ? addOn.configuration.subscriptionAcquires : "";
  return childAddOnName;
}

export function getParentAddOnFromSubscriptionInherits(childAddOn, parentAddOnName) {
  if (childAddOn.configuration.subscriptionInherits) {
    const parentAddOnsNames = childAddOn.configuration.subscriptionInherits?.split(",") || [];
    if (parentAddOnsNames?.length <= 0) {
      return null;
    }
    if (parentAddOnsNames?.length > 0) {
      return parentAddOnsNames.find(addonName => addonName === parentAddOnName);
    }
  }
  return null;
}

export function getParentAddOnFromChildSubscriptionInherits(childAddOn) {
  let parentAddOnName = null;
  if (childAddOn.configuration.subscriptionInherits) {
    const parentAddOnsNames = childAddOn.configuration.subscriptionInherits?.split(",") || [];
    if (parentAddOnsNames?.length <= 0) {
      return null;
    }
    for (let i = 0; i < parentAddOnsNames.length; i++) {
      const pAddOnName = parentAddOnsNames[i];
      const parentAddOn = getAddOnByName(pAddOnName);
      const childAddOnName = getChildAddOnFromAcquires(parentAddOn);
      if (childAddOnName === childAddOn.name) {
        parentAddOnName = pAddOnName;
        break;
      }
    }
    return parentAddOnName;
  }
  return null;
}

export function getMultiTaggedAddOnContent(isUserSubscribedToAsset, addonContent, subscriptionPerCountry) {
  const {
    applicationState: { country }
  } = this.props;
  let multiTaggedAddOnContent = null;
  if (!isUserSubscribedToAsset && subscriptionPerCountry) {
    multiTaggedAddOnContent = subscriptionPerCountry[country.toUpperCase()]
      ? subscriptionPerCountry[country.toUpperCase()]
      : subscriptionPerCountry[DEFAULT];
  }
  multiTaggedAddOnContent = multiTaggedAddOnContent
    ? multiTaggedAddOnContent
    : isUserSubscribedToAsset
    ? isUserSubscribedToAsset
    : addonContent;
  return multiTaggedAddOnContent;
}
